import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setAuthToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (data?.session_token) setAuthToken(data.session_token);
        else if (data?.access_token) setAuthToken(data.access_token);
        setUser(data);
        const dest = data.role === "admin" ? "/admin" : data.role === "artist" ? "/artist" : data.role === "referrer" ? "/referrer" : "/";
        navigate(dest);
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center font-sans">
      <div className="overline text-neutral-400">Connecting...</div>
    </div>
  );
}
